/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/28/20
 * Time: 1:37 PM
 */
import React,{Component} from 'react';
import success_icon from "../../../../assets/img/sweet/success.svg";
import error_icon from "../../../../assets/img/sweet/cry.svg";

class App extends Component{
  render() {
    let {responseResult,responseMessage,responseClassName} = this.props;
    return (
      <div className="swal-overlay swal-overlay--show-modal" tabIndex="-1">
        <div className={`swal-modal ${responseClassName}`} role="dialog" aria-modal="true">
              <div className="swal-icon swal-icon--custom">
                <img src={
                  responseResult ? success_icon : error_icon
                }/>
              </div>
          <div className="swal-title align-left swal-weight-500" dangerouslySetInnerHTML={{__html: responseMessage}}>

          </div>
          <div className="swal-footer">
                <div className="swal-button-container">
                  <div className="swal-button-container">
                    <button className="swal-button swal-button--dangerMode okay-btn" onClick={()=>this.props.closeModalHandler(responseResult)}>Okay</button>

                    <div className="swal-button__loader">
                      <div/>
                      <div/>
                      <div/>
                    </div>

                  </div>
                </div>
          </div>
        </div>
      </div>
    );
  }
}
export default App;
